"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEDSStore = void 0;
const zustand_1 = require("zustand");
const initialState = {
    edsInfoForm: null,
    edsEnabled: null,
    edsApplicant: null,
    edsPrequalID: null,
    blackboxData: null,
    edsPersonalInfo: null,
    edsOffer: null,
    edsResult: null,
};
/**
 * @description Set the applicant data from the API response from the Intro form
 */
exports.useEDSStore = (0, zustand_1.create)((set) => ({
    ...initialState,
    reset: () => set(initialState),
}));
